import React from 'react';

const VerticalImageCard = ({ imageSrc, title }) => {
  return (
    <div className="ml-5 flex w-80 flex-col items-center pb-5 rounded-md bg-background-primary shadow-md">
      <div className="relative w-full rounded-t h-80 bg-text-secondary  overflow-hidden">
        <img
          src={imageSrc}
          alt={title}
          className="absolute inset-0 object-cover w-full h-full"
        />
      </div>
      <h3 className="text-xl text-blue2 text-center font-bold mt-4">{title}</h3>
    </div>
  );
};

export default VerticalImageCard;
